import { useState } from 'react';
import axiosInstance from '../../api/axios';

const EditUserDialog = ({ data, handleEditUserDialog }) => {
  const [inputFields, setInputFields] = useState({
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    password: data.password
  });

  const handleChangeInputFields = (e) => {
    setInputFields({ ...inputFields, [e.target.name]: e.target.value });
  };

  const patchUser = async () => {
    await axiosInstance.patch(`user/${data.id}`, {
      ...inputFields
    });
    handleEditUserDialog();
  };

  return (
    <div className="wrapper">
      <div className="dialog">
        <div className="dialog__header">Izmeni korisnika</div>
        <div className="dialog__body">
          <label>Ime:</label>
          <input
            type="text"
            placeholder="Ime"
            className="dialog__input"
            name="firstName"
            value={inputFields.firstName}
            onChange={handleChangeInputFields}
          />
          <label>Prezime:</label>
          <input
            type="text"
            placeholder="Prezime"
            className="dialog__input"
            name="lastName"
            value={inputFields.lastName}
            onChange={handleChangeInputFields}
          />
          <label>Email adresa:</label>
          <input
            type="email"
            placeholder="Email adresa"
            className="dialog__input"
            name="email"
            value={inputFields.email}
            onChange={handleChangeInputFields}
          />
          <label>Lozinka:</label>
          <input
            type="password"
            placeholder="Lozinka"
            className="dialog__input"
            name="password"
            value={inputFields.password}
            onChange={handleChangeInputFields}
          />
        </div>
        <div className="dialog__footer">
          <button onClick={patchUser}>Potvrdi</button>
          <button onClick={handleEditUserDialog}>Otkaži</button>
        </div>
      </div>
    </div>
  );
};

export default EditUserDialog;
